var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMercado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6763 5.89996V14.1433H9.86345V9.18318H7.39986V14.1412H6.57799V7.53855H4.11942V14.1392H3.29755V10.001H0.805755V14.1523H0V14.9691H14V14.1483H13.1761V5.89795L10.6763 5.89996Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.996 4.2502H13.1761V2.36889L8.64375 6.87174L5.36231 3.58751L0.718141 8.20617L0.170227 7.66132L5.31598 2.43738L8.61757 5.73872L12.4791 1.79282H10.6863V0.968994H13.996V4.2502Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercado);
export default __webpack_public_path__ + "static/media/Mercado.2829c5143eb9e49a8e69c4ca294b78da.svg";
export { ForwardRef as ReactComponent };